<template>

  <div>
    <md-toolbar class="md-primary">
      <h3 class="md-title" style="flex: 1">Ordini di carico</h3>
      <md-button class="md-icon-button" to="/carico/upload">
        <md-icon>upload</md-icon>
      </md-button>
      <md-button class="md-icon-button" to="/carico/nuovo">
        <md-icon>add</md-icon>
      </md-button>
    </md-toolbar>
    <CaricoFiltri v-on:ricerca-ordini="fetchData" style="margin-bottom: 20px;"></CaricoFiltri>
    <md-table v-model="ordiniCarico" md-card @md-selected="onSelect">
      <md-table class="fullScreen">
        <md-table-row class="tableHeader">
          <md-table-head class="status">&nbsp;</md-table-head>
          <md-table-head>Delivery Note</md-table-head>
          <md-table-head>Order Date</md-table-head>
          <md-table-head>Delivery Date</md-table-head>
          <md-table-head>Transport mean</md-table-head>
          <md-table-head>Gross weight</md-table-head>
          <md-table-head>Magazzino</md-table-head>
          <md-table-head>Pos</md-table-head>
          <md-table-head>Num. magazzino</md-table-head>
          <md-table-head>SAP</md-table-head>
          <md-table-head>ELOGATE</md-table-head>
          <md-table-head>Barcode tot.</md-table-head>
          <md-table-head>Barcode disp.</md-table-head>
          <md-table-head class="action">&nbsp;</md-table-head>
        </md-table-row>
        <template v-for="row in ordiniCarico">
                  <md-table-row :key="row.id" :class="{'incomplete' : row.incomplete}">
                    <md-table-cell class="status"><md-icon v-show="row.incomplete">error_outline</md-icon></md-table-cell>
                    <md-table-cell>{{row.deliveryNote}}</md-table-cell>
                    <md-table-cell>{{row.orderDateIta}}</md-table-cell>
                    <md-table-cell>{{row.deliveryDateIta}}</md-table-cell>
                    <md-table-cell>{{row.transportMean}}</md-table-cell>
                    <md-table-cell>{{row.grossWeight.quantity}} / {{row.grossWeight.unit}}</md-table-cell>
                    <md-table-cell>{{row.depotDesc}}</md-table-cell>
                    <md-table-cell>{{row.pos}}</md-table-cell>
                    <md-table-cell>{{row.numeroMagazzino}}</md-table-cell>
                    <md-table-cell>{{row.sap}}</md-table-cell>
                    <md-table-cell>{{row.elogate}}</md-table-cell>
                    <md-table-cell>{{row.barcode_totali}}</md-table-cell>
                    <md-table-cell>{{row.barcode_totali - row.barcode_scaricati}}</md-table-cell>
                    <md-table-cell class="action">
                      <md-button class="md-icon-button md-dense" @click="onEditRow(row)">
                        <md-icon>edit</md-icon>
                      </md-button>
                      <md-button class="md-icon-button md-dense" @click="onDeleteRow(row)">
                        <md-icon>delete</md-icon>
                      </md-button>
                      <md-button class="md-icon-button md-dense" @click="viewPdf(row)" v-show="row.pdf != ''">
                        <md-icon>picture_as_pdf</md-icon>
                      </md-button>                      
                    </md-table-cell>
                  </md-table-row>
                </template>
      </md-table>
    </md-table>
    <md-card>
      <md-card-content>
          <div class="pager">
            <md-button class="md-icon-button" @click="prev()" :disabled="pager.page == 1" v-bind:class="{'md-raised' : pager.page > 1}">
              <md-icon>navigate_before</md-icon>
            </md-button>
            <div class="current">Pag. {{pager.page}}/{{pager.max}}</div>
            <md-button class="md-icon-button" @click="next()" :disabled="pager.page >= pager.max" v-bind:class="{'md-raised' : pager.page < pager.max}">
              <md-icon>navigate_next</md-icon>
            </md-button>
          </div>
      </md-card-content>
    </md-card>
  </div>

</template>

<script>
import CaricoFiltri from './CaricoFiltri.vue'

  export default {
    name: 'Carico',
    data: () => ({
      ordiniCarico: [],
      depots: {},
      filtri: {
        deliveryNote: '',
        depot: 0,
        orderDateFrom: '',
        orderDateTo: '',
        deliveryDateFrom: '',
        deliveryDateTo: '',
        sap : '',
        elogate : '',
        transportMean : '',
        reset : false
      },
      pager: {
        page : 1,
        max : 1
      }
    }),
    components: {
      CaricoFiltri
    },
    mounted() {
      this.depots = window.appCfg.depots
      this.fetchData()
    },
    methods: {
      next() {
        this.pager.page = Math.min(++this.pager.page, this.pager.max)
        this.fetchData(this.filtri)
      },
      prev() {
        this.pager.page = Math.max(--this.pager.page, 1)
        this.fetchData(this.filtri)
      },
      viewPdf(row) {
        window.open("/data/view-pdf?id=" + row.id, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes");
      },
      onEditRow(item) {
        this.$router.push({ path: '/carico/edit/' + item.id })
      },
      onDeleteRow(item) {
        this.$fire({
          title: 'Sei sicuro?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            this.$http
              .post(
                '/data/carico',
                { action: 'delete', what: 'head', id: item.id },
                { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
              )
              .then(deleteResponse => {
                if (deleteResponse.data.done) {
                  this.$fire({
                    title: 'Cancellato!',
                    html: "L'ordine di carico &egrave; stato cancellato",
                    type: 'success'
                  }).then(r => {
                    this.fetchData(this.filtri)
                  })
                } else {
                  this.$fire({
                    html: deleteResponse.data.message,
                    type: 'error'
                  }).then(r => {
                    if (response.data.bu != '') this.$router.push(response.data.bu)
                  })
                }
              })
          }
        })
      },
      async fetchData(filtri) {
        if (filtri) this.filtri = filtri
        if (this.filtri.reset) {
          this.pager =  {
            page : 1,
            max : 1
          }
        }
        let loading = this.$loading.show();
        try {
          const params = { action: 'list' , filters : filtri, page : this.pager.page}
          const response = await this.$http.post('/data/carico', params, {
            headers: { Authorization: 'Bearer ' + this.$cookie.get('token') }
          })
          loading.hide()
          if (!response.data.done) {
            this.pager =  {
              page : 1,
              max : 1
            }
            this.$fire({
              html: response.data.message,
              type: 'error'
            }).then(r => {
              if (response.data.bu != '') this.$router.push(response.data.bu)
            })
            return
          }
          this.ordiniCarico = response.data.data
          this.pager = response.data.pager
        } catch (err) {
          loading.hide()
          if (err.response) {
            this.$fire({
              text: 'Server error: ' + err,
              type: 'error'
            })
          } else if (err.request) {
            this.$fire({
              text: 'Network error: ' + err,
              type: 'error'
            })
          } else {
            this.$fire({
              text: 'System error: ' + err,
              type: 'error'
            })
          }
        }
      }
    }
  }

</script>

<style lang="css" scoped>

  .md-table + .md-table {
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Carico.vue